import { useAuth } from "@elit-hair/elit-tools";
import { AnyRoute, useRouter } from "@tanstack/react-router";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { DarwinPage } from "@/types/chatbot.types";

import { buildDarwinPageCatalog } from "./darwin-page-catalog";

export function useDarwinPageCatalog(): DarwinPage[] {
    const router = useRouter();
    const { userData } = useAuth();
    const { t } = useTranslation();
    const permissionCodes = userData?.permissionCodes;

    return useMemo(
        () =>
            buildDarwinPageCatalog({
                routes: Object.values(router.routesByPath) as AnyRoute[],
                permissionCodes: permissionCodes ?? [],
                translate: t,
            }),
        [router, permissionCodes, t]
    );
}
